import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BodyDefault, JsonReturn, ObjectParam } from './interface/generic-interface';
import { NotificationService } from './notification.service';

@Injectable()
export class ApiConService 
{
    token: any;
    private bodyDefault: BodyDefault;

    constructor (
      private http: HttpClient,
      private notificationService: NotificationService
    ) { }


    public async post(instanceName: string, objParam?: ObjectParam): Promise<JsonReturn>
    {
        this.bodyDefault.objParam = objParam;
        const retorno =  await this.http.post<JsonReturn>(environment.restApiURL + instanceName, this.bodyDefault).toPromise();
        if(!retorno.sucesso){
          this.notificationService.showErro(retorno.msg)
        }
        delete this.bodyDefault.objParam;
        return retorno;
    }

    public async put(instanceName: string, id: string,  objParam?: ObjectParam): Promise<JsonReturn>
    {
        this.bodyDefault.objParam = objParam;
        const retorno = await this.http.put<JsonReturn>(environment.restApiURL + instanceName + '/' + id, this.bodyDefault).toPromise();
        if(!retorno.sucesso){
          this.notificationService.showErro(retorno.msg)
        }
        delete this.bodyDefault.objParam;
        return retorno
    }
  
    public async putBody(instanceName: string, objParam: ObjectParam): Promise<JsonReturn> {
      try {
        this.bodyDefault.objParam = {
          roteiroAlerta: {
            RoteiroAlertaID: objParam.roteiroAlerta.RoteiroAlertaID
          }
        };
        const retorno = await this.http.put<JsonReturn>(environment.restApiURL + instanceName, this.bodyDefault).toPromise();
        if (!retorno.sucesso) {
          this.notificationService.showErro(retorno.msg);
        }
        delete this.bodyDefault.objParam; 
        return retorno;
      } catch (error) {
        console.error('Erro na requisição:', error);
      }
    }


    public async patchBodyRoteiro(instanceName: string, objParam: ObjectParam): Promise<JsonReturn> {
      try {
        this.bodyDefault.objParam = {
          filtroRoteiro: {
            dtPrevisoSaida: objParam.filtroRoteiro.dtPrevisoSaida,
            movDia: objParam.filtroRoteiro.movDia
          }
        };
        const retorno = await this.http.patch<JsonReturn>(environment.restApiURL + instanceName, this.bodyDefault).toPromise();
        if (!retorno.sucesso) {
          this.notificationService.showErro(retorno.msg);
        }
        delete this.bodyDefault.objParam; 
        return retorno;
      } catch (error) {
        console.error('Erro na requisição:', error);
      }
    }

    private gerarToken()
    {        
        this.token = 
        {
            headers: new HttpHeaders
            ({
                'Authorization': btoa('{"usuarioLogado": "'+ environment.usuarioLogado +'", "baseDados":"'+ environment.baseDados +'", "servidor":"'+ environment.servidor +'"}')
            })
        };
    }

    public async patch(instanceName: string): Promise<JsonReturn>
    {
        const retorno = await this.http.patch<JsonReturn>(environment.restApiURL + instanceName, this.bodyDefault).toPromise();
        if(!retorno.sucesso) this.notificationService.showErro(retorno.msg);
        delete this.bodyDefault.objParam; 
        return retorno;
    }

    public async patchInit() 
    {
      let retorno =  await this.http.patch<JsonReturn>(environment.restApiURL + 'authDistribuidora', 
        {
          "cnpj": environment.baseDados,
          "authKey": "見つかりません"
        }
        ).toPromise();
      if(retorno.sucesso){
        this.bodyDefault = {
          cnpj: retorno.response.distribuidora.cnpj,
          serverID: retorno.response.distribuidora.serverID,
          dbName: retorno.response.distribuidora.dbName,
          authKey:  "見つかりません"
        }
      } else{
        this.notificationService.showErro(retorno.msg)
      }
      return retorno;
    }

    public async patchGeraRoteiro(instanceName: string, objParam: ObjectParam): Promise<JsonReturn> {
      try {
        this.bodyDefault.objParam = {
          jasperURL: {
            JasperName: objParam.jasperURL.JasperName,
            JasperParam: objParam.jasperURL.JasperParam,
            JasperTipo: objParam.jasperURL.JasperTipo
          }
        };
        const copyBody = JSON.parse(JSON.stringify(this.bodyDefault));      
        delete this.bodyDefault.objParam;
        const retorno = await this.http.patch<JsonReturn>(environment.restApiURL + instanceName, copyBody).toPromise();
        if (!retorno.sucesso) {
          this.notificationService.showErro(retorno.msg);
        }
        return retorno;
      } catch (error) {
        console.error('Erro na requisição:', error);
      }
    }
}